import React from "react"
import PropTypes from "prop-types"

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { red } from '@mui/material/colors';


const defaultTheme = createTheme();

const theme = createTheme({
  palette: {
    primary: {
      main: '#3376C2',
      dark: '#2D4666'
    },
    secondary: {
      main: '#77D3A8'
    },
    error: {
      main: red.A400
    }
  },
  typography: {
    subtitle1: {
      fontWeight: 500
    },
    h4: {
      fontWeight: 500
    },
    h5: {
      fontWeight: 100,
      lineHeight: '1.334',
    },
    body2: {
      color: 'rgba(0, 0, 0, 0.6)'
    }
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ...(ownerState.selected && {
            color: '#212121!important'
          })
        })
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            height: '2px',
            width: '100%',
            bottom: 0,
            left: 0,
            backgroundColor: '#757575'
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#212121',
            height: '3px'
          }
        }
      }
    },
    MuiCollapse: {
      styleOverrides: {
        root: {
          '& .MuiList-root': {
            paddingLeft: 20,
            paddingRight: 20
          }
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          borderRadius: '10px',
          paddingTop: 10,
          paddingBottom: 10,
          ...(ownerState.selected && {
            backgroundColor: `${theme.palette.primary.dark}!important`
          })
        })
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10
        }
      }
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'lightweight' },
          style: {
            textTransform: 'capitalize',
            color: defaultTheme.palette.text.secondary,
            backgroundColor: '#DFDFDF',
            borderRadius: 4,
            paddingBottom: 0.5,
            paddingTop: 0.5
          }
        }
      ],
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          '&.active': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)'
          }
        },
        outlined: {
          borderColor: '#C7C9D9'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.selected && {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
          })
        }),
        head: {
          borderColor: 'rgba(0, 0, 0, 0.87)',
          borderWidth: 2
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          fontWeight: 500
        }
      }
    }
  }
});



const Theme = (props) => {
  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        {props.children}
      </ThemeProvider>
    </React.Fragment>
  )
}


export default Theme
